<template>
  <div class="home">
    <div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light banner">
      <div class="col-md-5 p-lg-5 mx-auto my-5">
        <h1 class="display-4 font-weight-normal logo">For the guests</h1>
        <!-- <p class="lead font-weight-normal">Beautiful cards &amp; sites for every occasion.</p> -->
        <p class="lead font-weight-normal">Beautifully, hand crafted wedding sites for your guests.</p>
        <!-- <a class="btn btn-outline-secondary" href="#">Sign up</a> -->
      </div>
      <div class="product-device box-shadow d-none d-md-block"></div>
      <div class="product-device product-device-2 box-shadow d-none d-md-block"></div>
    </div>
    <div class="container">
      <div class="row">

      <!-- Begin MailChimp Signup Form -->
        <div class="col-4 text-center" id="mc_embed_signup" >
        <form action="https://cg.us1.list-manage.com/subscribe/post?u=029b906aaedcd0035a006c24b&amp;id=7686f378ea" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
          <div id="mc_embed_signup_scroll">
            <div class="mc-field-group">
            	<label for="mce-EMAIL">Email</label>
            	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
            </div>
        	<div id="mce-responses" class="clear">
        		<div class="response" id="mce-error-response" style="display:none"></div>
        		<div class="response" id="mce-success-response" style="display:none"></div>
        	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_029b906aaedcd0035a006c24b_7686f378ea" tabindex="-1" value=""></div>
            <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
          </div>
        </form>
        </div>
        <!--End mc_embed_signup-->



        <div class="col-4" v-for="theme in getThemes" :key="theme['.key']" style="display:none;">
          <div class="card">
            <img class="card-img-top" v-bind:src="'/static/themes/' + theme.slug + '/preview.jpg'" v-bind:alt="theme.name + ' Preview'">
            <div class="card-body">
              <h5 class="card-title">{{ theme.name }}</h5>
              <p class="card-text">{{ theme.description }}</p>
              <div class="d-flex justify-content-between" v-for="option in theme.options" :key="option['.key']">
                <span class="price">${{ theme.price }}</span>
                 <router-link :to="{ name: 'Customize', params: { theme_id: theme['.key'] }}" class="btn btn-primary">Customize</router-link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dbThemesRef } from '../firebaseConfig'

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters ([
      'getThemes',
    ])
  },
  methods: {
    // customize(theme, option) {
      // dbCartRef.push({
      //   name: theme.name,
      //   slug: theme.slug,
      //   price: option.price
      // })

      // this.cart.push({
      //   name: item.name,
      //   slug: item.slug,
      //   price: option.price,
      // })
      // this.$router.push({path: '/customize/' + theme.slug})
      // console.log(this.cart)
   // }
  }
}
</script>

<style scoped>
.logo {
  text-transform: uppercase;
  font-size: 38px;
  letter-spacing: 4px;
}
.card-img-top {
  background-color: grey;
  min-height: 180px;
}
.banner {
  /* background-image:url(https://fortheguests.com/assets/annie-gray-376049.jpg); */
  background-position: top middle;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue